import React from "react";
import { Sparkles } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal";

const FounderSection: React.FC = () => {
  return (
    <section id="why" className="py-24 md:py-32 px-6 relative overflow-hidden">
      <div className="container mx-auto max-w-5xl">
        <div className="grid md:grid-cols-[0.85fr_1.15fr] gap-12 md:gap-16 items-center">
          <ScrollReveal direction="left">
            <div className="relative aspect-[4/5] cosmic-card overflow-hidden">
              <div className="absolute inset-0 bg-cosmic-radial opacity-60" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] h-[60%] rounded-full bg-cosmic-500/20 blur-3xl animate-pulse" />
              <div className="absolute inset-0 flex items-end justify-center pb-6">
                <span className="text-xs uppercase tracking-[0.14em] text-cosmic-200 bg-cosmic-900/60 backdrop-blur px-3 py-1.5 rounded-full border border-cosmic-400/30">
                  Founder portrait
                </span>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" delay={120}>
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium tracking-wide text-cosmic-200 border border-cosmic-400/30 bg-cosmic-900/50 backdrop-blur-sm">
                Why we built it
              </span>
              <h2 className="mt-4 text-4xl md:text-5xl font-display font-bold text-white leading-tight">
                I knew the law. I still woke up <span className="text-cosmic-gradient">flat</span>.
              </h2>
              <p className="mt-6 italic text-xl text-white/90 leading-snug">
                "I'd read all the books. I believed every word of them. And I still couldn't find a
                way to actually <i>feel</i> the life I wanted, not for more than a passing
                moment."
              </p>
              <div className="mt-6 space-y-4 text-white/70 leading-relaxed">
                <p>
                  Vision boards went stale on the wall. Affirmations felt like reading someone
                  else's lines. The ideas were right, but there was no practice to make them land
                 , nothing that let me step inside the feeling and stay there long enough for it
                  to change me.
                </p>
                <p>
                  So I built the thing I couldn't find. A daily practice crafted around the
                  metaphysical laws, your real life woven into the future you're building,
                  somewhere you can go each morning to feel it real before it's real. Not to chase
                  the feeling, but to live from it.
                </p>
                <p>
                  I made it from a small town in Northland, between a young family and a head full
                  of plans. It's the first thing I open most mornings. I think it might do the
                  same for you.
                </p>
              </div>
              <div className="mt-8 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-cosmic-500/30 border border-cosmic-400/30 grid place-items-center text-cosmic-200">
                  <Sparkles className="h-5 w-5" />
                </div>
                <div>
                  <div className="text-2xl italic text-cosmic-gradient font-display leading-none">
                    Hamosi
                  </div>
                  <div className="text-sm text-white/50 mt-1">Founder, Mindmail</div>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
